/** Validated env config — fail-fast on missing/invalid VITE_* vars. */
import { z } from "zod";

const boolFromString = z
  .union([z.boolean(), z.string()])
  .transform((v) => (typeof v === "boolean" ? v : v.toLowerCase() === "true"))
  .pipe(z.boolean());

const schema = z.object({
  VITE_API_CENTRAL_BASE_URL: z.string().url(),
  VITE_KEYCLOAK_URL: z.string().url(),
  VITE_KEYCLOAK_REALM: z.string().min(1),
  VITE_KEYCLOAK_CLIENT_ID: z.string().min(1),
  VITE_TENANT_ID: z.string().min(1),
  VITE_APP_BASE_URL: z.string().url(),
  VITE_DEFAULT_WORKER_URL: z
    .string()
    .url()
    .optional()
    .or(z.literal("").transform(() => undefined)),
  VITE_FEEDBACK_ENABLED: boolFromString.default(false),
  VITE_FEEDBACK_URL: z.preprocess(
    (v) => (v === "" ? undefined : v),
    z.string().url().default("http://localhost:24000/api/v1/public/feedback"),
  ),
  VITE_FEEDBACK_APP_ID: z.string().default("senacle-workforce"),
  VITE_FEEDBACK_BRANCH: z
    .string()
    .optional()
    .or(z.literal("").transform(() => undefined)),
  VITE_FEEDBACK_COMMIT: z
    .string()
    .optional()
    .or(z.literal("").transform(() => undefined)),
});

export type ParsedEnv = z.infer<typeof schema>;

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  throw new Error(
    "Invalid VITE_* environment configuration:\n" +
      JSON.stringify(parsed.error.format(), null, 2),
  );
}

export const env: ParsedEnv = parsed.data;
